import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, Validator } from '@angular/forms';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';

@Directive({
	selector: '[appEmailExists][formControlName],[appEmailExists][formControl],[appEmailExists][ngModel]',
	providers: [
		{
			provide: NG_ASYNC_VALIDATORS,
			useExisting: forwardRef(() => EmailExistsValidator),
			multi: true
		}
	]
})
export class EmailExistsValidator implements Validator {
	constructor(private _authenticationService: AuthenticationService,
				private _userService: UserService) {
	}

	validate(c: AbstractControl): Promise<{ [key: string]: any }> {
		return new Promise(resolve => {
			if (c.value == null || c.value.length === 0) {
				resolve(null);
			} else {
				let user = this._userService.getUser();
				let userEmail: string;
				if (user && user.inetUser) {
					userEmail = user.inetUser.email;
				}
				let data = {
					emailAddress: c.value,
					userType: user ? user.type : 'inet'
				};
				this._authenticationService.emailExists(data).subscribe(response => {
					if (!response || response && c.value === userEmail) {
						resolve(null);
					} else {
						resolve({emailTaken: true});
					}
				});
			}
		});
	}
}
